import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
export default grapesjs.plugins.add('ai-chatBot-messaging', (editor, opts = {}) => {
  let options = opts || {};

  let defaults = {
    pfx: 'ai-chatBot-messaging',
    blocks: ['ai-chatBot-messaging'],
    defaultStyle: true,
    label: 'Ai Chatbot Message',
    category: 'Advanced',
    type: 'ai-chatBot-messaging',
  };

  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }

  loadComponents(editor, options);
  loadBlocks(editor, options);
});
